'use client'

import { useEffect, useState } from 'react'

// Shared bits for every widget's footer: the button style, the three link
// icons, and a hook that tells whether the widget is rendered in popup/embed
// mode (?do=pop), where the links are hidden and only the logo remains.

export const WIDGET_FOOTER_BTN =
    'inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-gray-200 bg-white text-gray-700 text-sm font-medium text-left hover:border-blue-500 hover:text-blue-600 hover:bg-blue-50 transition-colors'

// True when the page URL carries ?do=pop (the embedded/popup widget view).
export function useIsPopup(): boolean {
    const [isPopup, setIsPopup] = useState(false)
    useEffect(() => {
        try {
            setIsPopup(new URLSearchParams(window.location.search).get('do') === 'pop')
        } catch {
            /* ignore */
        }
    }, [])
    return isPopup
}

export function IconSuggest() {
    return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0" aria-hidden="true">
            <path d="M9 18h6M10 21h4" />
            <path d="M12 2a6 6 0 0 0-3.5 10.9c.5.4.8 1 .9 1.6h5.2c.1-.6.4-1.2.9-1.6A6 6 0 0 0 12 2z" />
        </svg>
    )
}
export function IconDownload() {
    return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0" aria-hidden="true">
            <path d="M12 3v12" /><path d="M7 11l5 5 5-5" /><path d="M5 21h14" />
        </svg>
    )
}
export function IconEmbed() {
    return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0" aria-hidden="true">
            <path d="M8 9l-3 3 3 3" /><path d="M16 9l3 3-3 3" />
        </svg>
    )
}
